import styled from 'styled-components';

const CookieLawBarHolder = styled.div`
    .cookie-law-bar {
        display: block;
        background-image: linear-gradient(to bottom right, #50545f, #1e1e1e);
        color: rgb(255, 255, 255);
        font-family: inherit;
        border-top: 2px solid rgb(68, 68, 68);
        position: fixed;
        bottom: 0px;
        padding: 10px 0;
        border: 0;
        text-align: center;
        width: 100%;
        z-index: 9999;

        .cookies-message {
            width: 80%;
            float: left;
            padding-left: 50px;

            a {
                color: #fff;
                text-decoration: underline;
            }
        }

        .cookies-buttons {
            width: 19%;
            float: left;

            .cookies-yes-button {
                float: right;
                background-color: rgb(122, 118, 82);
                color: rgb(255, 255, 255);
                display: inline-block;
                font-size: 15px;
                font-weight: 500;
                line-height: 1;
                padding: 8px 16px 8px;
                border-radius: 4px;
                position: relative;
                cursor: pointer;
                margin-left: 10px;
                text-decoration: none;
            }
        }
    }
`;

export default CookieLawBarHolder;